import { render, staticRenderFns } from "./smartAgriculture.vue?vue&type=template&id=346723a0&scoped=true"
import script from "./smartAgriculture.vue?vue&type=script&lang=js"
export * from "./smartAgriculture.vue?vue&type=script&lang=js"
import style0 from "./smartAgriculture.vue?vue&type=style&index=0&id=346723a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346723a0",
  null
  
)

export default component.exports